










































//import {db, functions} from "@/scripts/firebase";
import { ClassData } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
//import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
//import { User } from 'firebase';

@Component

export default class Class extends Mixins(Common) {
  classes: ClassData[] = []
  isLoading = false
  orderBy: keyof ClassData = 'creationTime'
  columns = [
    {
      field: 'name',
      order: true
    },
    {
      field: 'description',
    },
     {
      field: 'members',
    },
  ]

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const theUserClasss = await this.$getUserClassesQuery().get()
      this.classes = theUserClasss.docs.map( (doc) => {
        const row = doc.data()
        return {classId: doc.id,...row} as ClassData
      });
      console.log(this.classes)
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  sortUser(index: number){
    let orderBy = this.columns[index].field
    if(orderBy == 'role'){
      orderBy = 'accessLevel'
    }

    if(orderBy == 'firstName' || orderBy == 'lastName' ){
      orderBy += 'Yomigana'
    }

    if(this.orderBy == orderBy){
      this.columns[index].order = ! this.columns[index].order
    }else{
      this.orderBy = orderBy as keyof ClassData
    }

    this.classes.sort((a, b) => {
      const nameA = a[this.orderBy] || Number.MIN_SAFE_INTEGER
      const nameB = b[this.orderBy] || Number.MIN_SAFE_INTEGER

      if(nameA === nameB){
        return 0
      }else if(this.columns[index].order && nameA > nameB){
        return 1
      }else{
        return -1
      }
    });
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
